const MAIL_MAPPING = {
  CARRELLO_DELLA_SPESA: "mailto:carrellodellaspesa@essilorluxottica.com",
  BORSE_DI_STUDIO: "mailto:borsedistudio@essilorluxottica.com",
  CHECK_UP_SANITARIO: "mailto:checkup@essilorluxottica.com",
  OSTEOPATA: "mailto:familycare.milano@luxottica.com",
};

const Footer = ({ app = "SURVEY", setNavigation, labels, title }) => {
  return (
    <footer className="footer">
      <div className="wrapper">
        <div className="footer__logo">
          <span>{labels?.WELFARE_ESSILORLUXOTTICA_YEAR || "© EssilorLuxottica 2023"}</span>
        </div>
        <ul className="footer__links">
          {["CHECK_UP_SANITARIO", "OSTEOPATA"].includes(app) && title && (
            <li>
              <button onClick={() => setNavigation("info")} className="footer__link">
                <span>{title}</span>
              </button>
            </li>
          )}
          {app !== "SURVEY" && (
            <li>
              <a href={MAIL_MAPPING?.[app]} className="footer__link">
                <span>{labels?.CONTACT_US || "Contact us"}</span>
              </a>
            </li>
          )}
          <li>
            <button onClick={() => setNavigation("privacy-policy")} className="footer__link">
              <span>{labels?.WELFARE_PRIVACY_POLICY || "Privacy Notice"}</span>
            </button>
          </li>
          <li>
            <button onClick={() => setNavigation("cookie-policy")} className="footer__link">
              <span>{labels?.WELFARE_COOKIE_POLICY || "Cookie Policy"}</span>
            </button>
          </li>
          <li>
            <a href="/" target="_blank" rel="noreferrer" className="footer__link">
              <span>{labels?.WELFARE_ONE_ESSILORLUXOTTICA || "One EssilorLuxottica"}</span>
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
